export const generalStats = [
	{
		details: {
			number: '276',
			unit: 'jobs created',
			description: `Nearly 300 new positions were opened along the project’s production value chain, including youth-aged lower-skilled individuals and more advanced production personnel alike. 
            
            For a 6-month period, these individuals, across Oyo and Lagos states were provided with job security and a steady income source, amidst the economic downturn caused by the pandemic.`,
		},
		image: 'https://res.cloudinary.com/dpabcunnn/image/upload/v1628469758/general/impact-t-1_tatqe5.jpg',
	},
	{
		details: {
			number: '72.2%',
			unit: 'women employed',
			description: `There was a greater slant towards women across the new hires on the project’s production team. Of the 276 new jobs created, 80% was occupied by women. 
            
            Women’s ability to create a ripple by investing in the well-being of their children and families; their propensity for wealth-sharing; and the employment gap across genders in Nigeria made it imperative to prioritise their economic outcomes.`,
		},
		image: 'https://res.cloudinary.com/dpabcunnn/image/upload/v1628469756/general/mpact-t-3_wfoktv.jpg',
	},
	{
		details: {
			number: '500%',
			unit: 'income growth',
			description: `Before the pandemic, the average income recorded by the sample set was less than $250 a month. As a result of widespread lockdowns at the onset of the pandemic, and the resultant business slowdown, average incomes dropped steeply to under $60 per month. 
                
                Average income went up to over $360 per month - 44% higher than before and 500% higher than during the pandemic.`,
		},
		image: 'https://res.cloudinary.com/dpabcunnn/image/upload/v1628469756/general/mpact-t-4_i0mn7l.jpg',
	},
	// {
	// 	details: {
	// 		number: '44',
	// 		unit: 'bank accounts opened',
	// 		description: `Before the pandemic, the average income recorded by the sample set was less than $250 a month. As a result of widespread lockdowns at the onset of the pandemic, and the resultant business slowdown, average incomes dropped steeply to under $60 per month.`,
	// 	},
	// 	// image: 'https://res.cloudinary.com/dqyhh2jit/image/upload/q_auto/v1621960886/safeup/DMP_5803_b58cbm.jpg',
	// },
	{
		details: {
			number: '',
			unit: 'Production Efficiency Training',
			description: `An introductory session to teach new in-house production staff methods of ensuring consistently high production output.
            
            October 2020`,
		},
		image: 'assets/images/ProductionEfficiency Training.png',
	},
	{
		details: {
			number: '',
			unit: 'COVID Compliance Training',
			description: `A pre-project training session to educate new staff on COVID-19 and the various ways to avoid contracting the virus.
            
            October 2020`,
		},
		image: 'assets/images/CovidSensitisation.jpg',
	},
	{
		details: {
			number: '',
			unit: 'Sustainability Workshop',
			description: `A one-day interactive workshop to educate budding and existing entrepreneurs amongst the project’s production staff on ways to sustain their income growth and scale their businesses.
            
            April 2021`,
		},
		image: 'assets/images/Workshop.jpg',
	},
];
